import { render, staticRenderFns } from "./tourManage.vue?vue&type=template&id=2328aee6&scoped=true&"
import script from "./tourManage.vue?vue&type=script&lang=js&"
export * from "./tourManage.vue?vue&type=script&lang=js&"
import style0 from "./tourManage.vue?vue&type=style&index=0&id=2328aee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2328aee6",
  null
  
)

export default component.exports